<companyid-content-wrapper
    assetPath="footer"
    classNames="flex-col w-full py-80px gap-25px tab:px-5 mob:px-5 tab:items-center mob:items-center tab:text-center mob:text-center z-10"
>
    <span class="w-570px tab:w-full mob:w-full text-h3-bold text-white mob:text-h4-bold" i18n>
        Begin to expand your business with СompanyID
    </span>

    <companyid-get-started class="flex" />
    <span class="text-white text-small-regular" i18n>
        By submitting this form, I agree to the
        <a [routerLink]="privacyPolicyPath" class="underline">CompanyID Privacy Policy</a>
    </span>
</companyid-content-wrapper>
<hr class="w-screen border border-solid border-dark-3" />
<companyid-content-wrapper isDark classNames="flex-col items-center justify-between py-40px w-full tab:px-5 mob:px-5">
    <div class="flex w-full items-center gap-x-72px tab:gap-x-25px mob:flex-col mob:m-auto">
        <companyid-logo logoColor="white" class="mob:mb-60px mr-auto mob:m-auto" />
        @for (footer of footerNavigations; track footer.title) {
            <a [routerLink]="footer.route" class="text-small-medium text-white">
                {{ footer.title }}
            </a>
        }
    </div>
    <hr class="w-full border border-solid border-dark-3 my-30px" />

    <div
        class="flex justify-between items-center text-center text-primary-text-color text-extra-small-regular w-full tab:flex-col-reverse tab:gap-30px mob:flex-col-reverse mob:gap-30px"
    >
        <span>© <a href="https://jsdaddy.io/" target="_blank">JsDaddy,</a> {{ copyrightText }}</span>
        <div class="flex items-center gap-x-30px tab:flex-col-reverse tab:gap-30px mob:flex-col-reverse mob:gap-30px">
            <div class="flex items-center gap-x-30px">
                <a [routerLink]="privacyPolicyPath" i18n>Privacy Policy</a>
                <a routerLink="/terms-and-conditions" i18n>Terms and Conditions</a>
            </div>
            <companyid-social-media />
        </div>
    </div>
</companyid-content-wrapper>
